import { render, staticRenderFns } from "./lowerList.vue?vue&type=template&id=4ec557e4&scoped=true&"
import script from "./lowerList.vue?vue&type=script&lang=js&"
export * from "./lowerList.vue?vue&type=script&lang=js&"
import style0 from "./lowerList.vue?vue&type=style&index=0&id=4ec557e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec557e4",
  null
  
)

export default component.exports